import {Types} from "../types";

export const cs = (...services:Types.Common.React.ChainServices.ChainServicesNode[]) => gather(services, {});
export const cs1 = cs;

function gather(services: any[], variableStack: any): any {
    if (services.length === 0) {
        throw `next() is called in the last service`;
    }
    const [first, ...last] = services;
    let name;
    let fn;
    if (Array.isArray(first)) {
        name = first[0];
        fn = first[1];
    } else if (typeof first === "object") {
        name = first.name;
        fn = first.load;
    } else {
        fn = first;
    }

    return fn(variableStack, ret => gather(last,name !== undefined ? {...variableStack, [name]: ret} : variableStack));
}

// typed chain-service methods - cst for Chain Service Typed
// TODO: Remove ns (and move type to cstAssign) after all ns usage has been removed
export const cst = <t>(...services:Array<Types.Common.React.ChainServices.Service<t> | Types.Common.React.ChainServices.NamedService<t, keyof t>>) => cs(...services);
export const ns:Types.Common.React.ChainServices.MakeNamedServiceFunction = (name, service) => [name, service];
export const cstAssign = ns;
